<template>
  <div class="news-detail-page">
    <!-- 顶部横幅部分 -->
    <div class="section-banner"></div>

    <!-- 详情内容部分 -->
    <div class="detail-container">
      <div class="detail-card">
        <h2 class="detail-title">{{ newsDetail.title }}</h2>
        <div class="detail-date">{{ newsDetail.pubtime }}</div>
        <div class="detail-content" v-html="newsDetail.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getIndustryNewsDetailApi } from '@/api/index';

export default {
  name: 'NewsDetail',
  data() {
    return {
      newsDetail: {},
      loading: false,
      id: null
    }
  },
  created() {
    // 从路由获取新闻ID
    this.id = this.$route.params.id;
    if (this.id) {
      this.getNewsDetail();
    }
  },
  methods: {
    async getNewsDetail() {
      try {
        this.loading = true;
        // 调用新闻详情接口
        const res = await getIndustryNewsDetailApi({id: this.id});
        if (res && res.data) {
          this.newsDetail = res.data;
        } else {
          this.$message.error('获取新闻详情失败');
        }
      } catch (error) {
        console.error('获取新闻详情出错', error);
        this.$message.error('获取新闻详情失败');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-detail-page {
  width: 100%;
  color: #333;
}

// 顶部横幅
.section-banner {
  height: 400px;
  background-image: url('https://echance.oss-cn-beijing.aliyuncs.com/news-bg.png');
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: #fff;
}

// 详情内容
.detail-container {
  width: 1200px;
  margin: -80px auto 60px;
  position: relative;

  .detail-card {
    background-color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 40px 60px;
    border-radius: 4px;

    .detail-title {
      font-weight: bold;
      font-size: 28px;
      color: #333;
      text-align: center;
      margin-bottom: 20px;
    }

    .detail-date {
      font-size: 14px;
      color: #999;
      text-align: center;
      margin-bottom: 40px;
    }

    .detail-content {
      font-size: 16px;
      line-height: 1.8;
      color: #333;

      p {
        margin-bottom: 20px;
      }

      .signature {
        text-align: right;
        margin-top: 40px;
        margin-bottom: 5px;
      }

      .signature-date {
        text-align: right;
        margin-top: 0;
      }
    }
  }
}
</style>